export default __webpack_public_path__ + "static/media/README.7e0546b0.md";